import React, { useEffect, useState } from 'react';
import BasicInput from '../../TcIndex/Basic/BasicInput';

function HireValue({
    hire, countIndex, changeFieldsMultiple, required = false, setHasErrors, 
}) {
    const [stateHire, setStateIndex] = useState(hire);

    useEffect(() => {
        if (required) {
            if (!hire) {
                setHasErrors('hire', true);
            } else {
                setHasErrors('hire', false);
            }
        }
        setStateIndex(hire);
    }, [hire]);
    
    const changeHire = () => {
        hire !== stateHire && changeFieldsMultiple([
            {
                index: countIndex,
                field: 'hire',
                value: stateHire,
            },
        ]);
    };

    return (
        <BasicInput 
            name='hire'
            value={stateHire}
            onChange={e => setStateIndex(e.target.value)}
            floatingLabelStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            type='number'
            onBlur={changeHire}
        />
    );
}

export default React.memo(HireValue);



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/HireValue.jsx